// extracted by mini-css-extract-plugin
export default {"wrapper":"styles___wrapper___1Oy63","is-clickable":"styles___is-clickable___36qWU","wrapper--fixed":"styles___wrapper--fixed___2Ldnm"};